import EventBus from '../event-bus.js'
import jQuery from 'jquery'
import '../../google/modules/loader.js'
import '../../google/modules/maps.js'

class LocationAutocomplete {
    
    /**
     * Construct component
     * @param inputs
    */
    constructor(inputs) {
        
        /**
         * Autocomplete inputs
         * @type object
        */
        this.inputs = inputs
        
        this.bindEvents()
        
    }
    
    /**
     * All modules have been initialised
    */
    modulesInitialised() {
        EventBus.publish('load-google-places-library')
    }

    /**
     * Load Google API
    */
    loadGoogleApi() {
        EventBus.publish('load-google-api', this.googleApiLoaded.bind(this))
    }
    
    /**
     * Google API has been loaded
    */
    googleApiLoaded() {
        EventBus.publish('load-google-maps', this.googleMapsLoaded.bind(this))
    }
    
    /**
     * Google Maps API has been loaded
    */
    googleMapsLoaded() {
        
        let types
        
        this.inputs.each((i, element) => {
            
            var
                input = jQuery(element),
                autocomplete,
                dataAttr
            
            types = String(input.data('types')).split(',')

            autocomplete = new google.maps.places.Autocomplete(
                element,
                {types: types.length > 0 ? types : ['geocode']}
            )

            autocomplete.addListener('place_changed', () => {
                input.trigger('location-autocompleted', autocomplete.getPlace())
            })
            
            //Messy hack to over-ride the Chrome usability Nazis autofill Jihad!
            dataAttr = input.data('autocomplete')
            if (dataAttr) {
                setTimeout(() => {
                    input.attr('autocomplete', dataAttr)
                }, 500)
            }
            
        })
        
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        EventBus.subscribe('modules-initialised', this.modulesInitialised.bind(this))
        EventBus.subscribe('run-modules', this.loadGoogleApi.bind(this))
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    let inputs = jQuery('.location-autocomplete')
    
    if (inputs.length > 0) {
        new LocationAutocomplete(inputs)
    }
    
})

export default LocationAutocomplete